/**
 * Available permission actions per module
 * Used to build the permission matrix UI
 */
export const PERMISSION_ACTIONS = {
  dashboard: ["view", "view_all_companies", "export_csv", "edit_leads"],
  users: ["view", "create", "update", "delete", "reset_password"],
  companies: ["view", "create"],
  incentive: ["view"],
  reports: ["view"],
  roles_and_permissions: ["view", "create", "update", "reorder"],
  rate_review_portal: ["view", "edit"],
  admin_booking_config: ["view", "update"],
};

/**
 * Permission action labels for display
 * Maps permission keys to human-readable labels
 */
export const PERMISSION_LABELS = {
  dashboard: {
    view: "View",
    view_all_companies: "View All Companies",
    export_csv: "Export CSV",
    edit_leads: "Edit Leads",
  },
  users: {
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
    reset_password: "Reset Password",
  },
  companies: {
    view: "View",
    create: "Create",
  },
  incentive: {
    view: "View",
  },
  reports: {
    view: "View",
  },
  roles_and_permissions: {
    view: "View",
    create: "Create",
    update: "Update",
    reorder: "Reorder",
  },
  rate_review_portal: {
    view: "View",
    edit: "Edit",
  },
  admin_booking_config: {
    view: "View",
    update: "Update",
  },
};

/**
 * Create empty permissions structure
 * Used when creating new roles
 *
 * @returns {Object} Empty permissions object with all actions set to false
 */
export const createEmptyPermissions = () => {
  const permissions = {};

  Object.keys(PERMISSION_ACTIONS).forEach((module) => {
    permissions[module] = {};
    PERMISSION_ACTIONS[module].forEach((action) => {
      permissions[module][action] = false;
    });
  });

  return permissions;
};
